import React from 'react';

import styles from './style.module.css';

interface TextAreaProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  className: string;
  disabled?: boolean;
}

const TextArea: React.FC<TextAreaProps> = ({
  value,
  onChange,
  placeholder,
  className,
  disabled = false
}) => {
  return (
    <textarea
      data-test-id='textarea'
      className={`${styles.textArea} ${className}`}
      value={value}
      disabled={disabled}
      onChange={onChange}
      placeholder={placeholder}
    />
  );
};

export default TextArea;
